import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  selectLocationIndoorDeviceList
} from "../../../store/mapDeviceStore/mapDeviceSelectors";
import InfluenceArea from "../InfluenceArea";
import { selectCurrentMap } from "../../../store/mapStore/mapSelectors";
import { selectCurrentLocation } from "../../../store/locationStore/locationSelectors";
import { store, useTypedDispatch } from "../../../app/state";
import { requestAllDevicesByLocationId } from "../../../store/mapDeviceStore/mapDeviceRequest";
import { clearMapDeviceState } from "../../../store/mapDeviceStore/mapDeviceSlice";
import DeviceRenderer from "../DeviceRenderer";
import { selectEditMode } from "../../../store/generalStore/generalSelectors";
import { POINT_EDIT_TYPE, setEditMode } from "../../../store/generalStore/generalState";
import { pagePathGenerator } from "../../../routes/pagePathGenerator";
import useFilter from "../../../hooks/filter.hook";

const LocationMapStructureInfluenceArea = ({ deviceList, currentDeviceId, mapId, children, ...props }) => {
  const dispatch = useTypedDispatch();
  const history = useHistory();
  const currentMap = useSelector(selectCurrentMap);
  const locationInnerDeviceList = useSelector(selectLocationIndoorDeviceList(currentMap));
  const { state, actions } = useFilter();
  const { isLocation, showIndoorDeviceList, isAnyFilterChosen } = state;
  const locationInnerDeviceListFiltered = isAnyFilterChosen ? actions.filterDeviceList(locationInnerDeviceList) : locationInnerDeviceList;
  const currentLocation = useSelector(selectCurrentLocation);


  useEffect(() => {
    if (isLocation && currentLocation) {
      dispatch(requestAllDevicesByLocationId(currentLocation.id));

      return () => {
        dispatch(clearMapDeviceState());
      }
    }
  }, [ isLocation ]);

  const onDeviceClick = (id: number) => {
    const root = store.getState();
    const isMapPointEdit = selectEditMode(root);
    const isDrawing = isMapPointEdit === POINT_EDIT_TYPE.DRAWING;

    if (isDrawing || isMapPointEdit) {
      // skip device clicking while drawing or setting
      return;
    }
    dispatch(setEditMode(false));
    const url = pagePathGenerator.DEVICES_MAP({
      mapId,
      deviceId: id,
    });

    history.replace(url);
  }



  return (
    <InfluenceArea
      deviceList={showIndoorDeviceList ? [ ...deviceList, ...locationInnerDeviceListFiltered ] : deviceList}
      currentDeviceId={currentDeviceId}
      {...props}
    >
      <DeviceRenderer
        deviceList={showIndoorDeviceList ? [ ...deviceList, ...locationInnerDeviceListFiltered ] : deviceList}
        currentDeviceId={currentDeviceId}
        onClick={onDeviceClick}
      >
        {children}
      </DeviceRenderer>
    </InfluenceArea>
  );
}

export default LocationMapStructureInfluenceArea;